import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const AgriculturePage = lazy(() => import('../pages/agriculture/page'));
const PoultryPage = lazy(() => import('../pages/poultry/page'));
const LogisticsPage = lazy(() => import('../pages/logistics/page'));
const InsurancePage = lazy(() => import('../pages/insurance/page'));
const ExportPage = lazy(() => import('../pages/export/page'));
const CSDSupplierPage = lazy(() => import('../pages/csd-supplier/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/quote',
    element: <QuotePage />,
  },
  {
    path: '/agriculture',
    element: <AgriculturePage />,
  },
  {
    path: '/poultry',
    element: <PoultryPage />,
  },
  {
    path: '/logistics',
    element: <LogisticsPage />,
  },
  {
    path: '/insurance',
    element: <InsurancePage />,
  },
  {
    path: '/export',
    element: <ExportPage />,
  },
  {
    path: '/csd-supplier',
    element: <CSDSupplierPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
